module.exports = "<div class=\"hover-animation card  waves-effect\" routerLink=\"/evento/{{evento.id}}\">\r\n  <div class=\"card-image\">\r\n    <img src=\"{{evento.imgvertical}}\">\r\n  </div>\r\n  <div class=\"card-action\">\r\n    <a class=\"btn deep-orange\">Confira</a>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/hyago/Desktop/SiteEventos/src/app/inicio/eventos/evento/evento.component.html
// module id = ../../../../../src/app/inicio/eventos/evento/evento.component.html
// module chunks = main